export const content = {
  eyebrow: 'ViaCap®\u00A0Technology',
  background: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755552501/library/viacap/viacapbg.png',
    alt: 'ViaCap background',
  },
  backgroundVideo: {
    desktop: {
      playbackId: 'xww9WQg67VV0089Z7uunN3sSgnWhOo6z005YEq9ArP9lI',
      devPlaybackId: 'HZLxQ01KrbcSxSCwZfPI5ac6bbczCmuoTwyHUF72ejfg',
    },
    mobile: {
      playbackId: '00NC1RZPKERmq1OvN1ug9ZWliJgsNW9bjY00PGyIuNR800',
      devPlaybackId: 'HaYekpBRLhFe02l3sz2gmMn00VNF4meLZ9Hp100015CnZ00s',
    },
  },
  description: "Most probiotics don't survive digestion—DS-01® does.",
  note: {
    title: 'Increases healthy bacteria°',
    pill: 'DS-01®',
    performance: 17,
  },
  footnote: '°Lactobacillus',
};

export const capsuleLarge = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/video/upload/v1755019042/library/viacap/Seed-2025_3D-360-Product-Catalog_Capsule_DS01-Transparency_web-web_hd_720p.mov',
    fallbackSrc:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1756048619/library/viacap/viacap-fallback.gif',
    fallbackStillSrc:
      'https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/pg_1,f_png/v1756048619/library/viacap/viacap-fallback.png',
    alt: 'DS-01 3D 360° Product Catalog Capsule',
    type: 'video',
    width: 484,
    height: 484,
  },
  top: {
    title: 'OUTER CAPSULE',
    body: 'Shields probiotics from stomach acid in the digestive tract, while delivering prebiotics to stimulate the growth of beneficial bacteria.',
  },
  bottom: {
    title: 'INNER CAPSULE',
    body: "Delivers 24 live strains of probiotics to the colon, where they're needed most.",
  },
};

export const dmCapsuleLarge = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/video/upload/v1756818714/library/viacap/Seed_Capsule_DM02_C02_Motion-mov_hd_720p_small.mov',
    fallbackSrc:
      'https://res.cloudinary.com/dljz0lko8/image/upload/v1756818715/library/viacap/Seed_Capsule_DM02_C02_Motion-gif_large.gif',
    alt: 'DM-02 Viacap Display',
    type: 'video',
    width: 400,
    height: 400,
  },
};

export const capsuleSmall = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/video/upload/v1755019042/library/viacap/Seed-2025_3D-360-Product-Catalog_Capsule_DS01-Transparency_web-web_hd_720p.mov',
    fallbackSrc:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1756048619/library/viacap/viacap-fallback.gif',
    fallbackStillSrc:
      'https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/pg_1,f_png/v1756048619/library/viacap/viacap-fallback.png',
    alt: 'DS-01 3D 360° Product Catalog Capsule',
    type: 'video',
    width: 300,
    height: 300,
  },
  top: {
    title: 'Outer Capsule - For You',
    body: 'Shields probiotics from stomach acid in the digestive tract, while delivering prebiotics to stimulate the growth of beneficial bacteria.',
  },
  bottom: {
    title: 'Inner Capsule - For Your Microbiome',
    body: "Delivers 24 live strains of probiotics to the colon, where they're needed most.",
  },
};

const benefitsTestCapsuleCopy = {
  top: {
    title: 'Prebiotic Outer Capsule',
    body: 'Shields probiotics from stomach acid in the digestive tract, while delivering a prebiotic to stimulate the growth of beneficial bacteria.',
  },
  bottom: {
    title: 'Probiotic Inner Capsule',
    body: "Delivers 24 live strains of probiotics to the colon, where they're needed most.",
  },
};

export const benefitsTestCapsuleLarge = {
  ...capsuleLarge,
  ...benefitsTestCapsuleCopy,
};

export const benefitsTestCapsuleSmall = {
  ...capsuleSmall,
  ...benefitsTestCapsuleCopy,
};

export const benefitsTestPrimaryButton = {
  label: 'Shop DS-01®',
  url: '/daily-synbiotic',
};

// ° and Δ point to the FDA and Lactobacillus lines in the variant's footer
export const benefitsTestNoteTitle = 'increases healthy bacteria°Δ';
